__turbopack_context__.v({
  "heading": "b6066G_heading",
  "select": "b6066G_select",
});
